import CarrierAssembly from "@/pages/mill/carriers";
import { CarrierBuildFormPage } from "@/pages/mill/carriers/components/build/CarrierBuildFormPage";
import CobblesManager from "@/pages/mill/cobbles/manager";
import Dashboard from "@/pages/mill/gantt";
import MillOverview from "@/pages/mill/overview";
import MillOverview2 from "@/pages/mill/overview-2";
import RejectedManager from "@/pages/mill/rejected/manager";
import Campaign from "@/pages/mill/schedule";

export const routeCarrierAssembly = "mill/carriers-assembly";
export const routeMillOverview = "/mill/overview";
export const routeMillOverview2 = "/mill/overview-2";
export const routeMillSchedule = "/mill/schedule";
export const routeCobblesManager = "/mill/cobbles/manager";
export const routeRejectedManager = "/mill/rejected/manager";
export const routeMillGantt = "/mill/gantt";
export const millCarrierStatusPermission = "ui.navbar.mill.carrier.status";
export const millCobblesManagerPermission = "ui.navbar.mill.cobbles.manager";
export const millGanttPermission = "ui.navbar.mill.gantt";
export const millRejectedManagerPermission = "ui.navbar.mill.rejected.manager";
export const millSchedulePermission = "ui.navbar.mill.schedule";
export const millNavbarPermission = "ui.navbar.mill";
export const millOverview2Permission = "ui.navbar.mill.overview2";
export const millOverviewPermission = "ui.navbar.mill.overview";

export const millRoutes = [
	{
		path: routeCarrierAssembly,
		element: <CarrierAssembly />,
		permission: millCarrierStatusPermission,
	},
	{
		path: `${routeCarrierAssembly}/:partId`,
		element: <CarrierAssembly />,
		permission: millCarrierStatusPermission,
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/view/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: millCarrierStatusPermission,
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: millCarrierStatusPermission,
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId/answer-all`,
		element: <CarrierBuildFormPage />,
		permission: millCarrierStatusPermission,
	},
	{
		path: `${routeMillOverview}`,
		element: <MillOverview />,
		permission: millOverviewPermission,
	},
	{
		path: `${routeMillOverview2}`,
		element: <MillOverview2 />,
		permission: millOverview2Permission,
	},
	{
		path: `${routeMillSchedule}`,
		element: <Campaign />,
		permission: millSchedulePermission,
	},
	{
		path: `${routeMillSchedule}/:campaignId`,
		element: <Campaign />,
		permission: millSchedulePermission,
	},
	{
		path: `${routeCobblesManager}`,
		element: <CobblesManager />,
		permission: millCobblesManagerPermission,
	},
	{
		path: `${routeCobblesManager}/:shiftId`,
		element: <CobblesManager />,
		permission: millCobblesManagerPermission,
	},
	{
		path: `${routeRejectedManager}`,
		element: <RejectedManager />,
		permission: millRejectedManagerPermission,
	},
	{
		path: `${routeRejectedManager}/:shiftId`,
		element: <RejectedManager />,
		permission: millRejectedManagerPermission,
	},
	{
		path: `${routeMillGantt}`,
		element: <Dashboard />,
		permission: millGanttPermission,
	},
	{
		path: `${routeMillGantt}/:shiftId`,
		element: <Dashboard />,
		permission: millGanttPermission,
	},
];
